<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      show-footer
      :footer-method="footerMethod"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:currencyAmount="{ row }">
        <span>{{ row.currencyAmount }} {{ row.currencyUnit }}</span>
      </template>
      <template v-slot:receiveStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.receiveStatus == 'Y' ? 'success' : 'warning'"
        >
          {{ row.v_receiveStatus }}
        </el-tag>
      </template>
      <template v-slot:userReimbursementStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.userReimbursementStatus === 'N'
              ? 'primary'
              : row.userReimbursementStatus === 'S'
              ? 'warning'
              : row.userReimbursementStatus === 'Y'
              ? 'success'
              : row.userReimbursementStatus === 'D' ||
                row.userReimbursementStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.userReimbursementStatusText }}
        </el-tag>
      </template>
      <template v-slot:substituteInvoice="{ row }">
        <el-tag
          size="mini"
          :type="row.substituteInvoice === '0' ? 'primary' : 'warning'"
        >
          {{ row.substituteInvoiceText }}
        </el-tag>
      </template>
      <template v-slot:forwardGeneralManager="{ row }">
        <el-tag
          size="mini"
          :type="row.forwardGeneralManager === '0' ? 'primary' : 'warning'"
        >
          {{ row.forwardGeneralManagerText }}
        </el-tag>
      </template>
      <template v-slot:businessConsumption="{ row }">
        <el-tag
          size="mini"
          :type="row.businessConsumption === '0' ? 'primary' : 'warning'"
        >
          {{ row.businessConsumptionText }}
        </el-tag>
      </template>
      <template v-slot:otherSet="{ row }">
        <el-tag
          size="mini"
          :type="row.otherSet === '0' ? 'primary' : 'warning'"
        >
          {{ row.otherSetText }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      visible: false,
      finPaymentNoInvoice: '',
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return []
      if (this.tableData.length <= 0) return []
      const sumData = this.tableData[0].sumData

      let footerRow = [
        this.$l('INDEX.total') || '合计',
        '',
        '',
        '',
        sumData.rmbAmount,
        sumData.usdAmount,
        '',
      ]
      return [footerRow]
    },
  },
  methods: {
    footerMethod() {
      return this.footerData
    },
  },
}
</script>
